// Events schedule data - times are in server time (GMT+3)
// Days: 0 = Sunday, 1 = Monday, ..., 6 = Saturday

export const EVENTS_SCHEDULE = {
  // Monday
  1: [
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Forge Of The Gods' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Sailren в Primeval Isle' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:59', event: 'Караван' },
    { time: '12:10', event: 'Mini Battles' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Forge Of The Gods' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:52', event: 'Нападение на Dion' },
    { time: '16:13', event: 'Mini Battles' },
    { time: '16:30', event: 'Sailren в Primeval Isle' },
    { time: '16:43', event: 'Tower Defence' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:22', event: 'Pvp Location' },
    { time: '17:43', event: 'Захват флага' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Forge Of The Gods' },
    { time: '19:23', event: 'Tower Defence' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Epic Boss' },
    { time: '20:45', event: 'Domination' },
    { time: '22:10', event: 'Mini Battles' },
    { time: '22:30', event: 'Sailren в Primeval Isle' },
    { time: '22:58', event: 'Караван' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
    { time: '23:59', event: 'Нападение на Gludio' },
  ],
  // Tuesday
  2: [
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Forge Of The Gods' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Forge Of The Gods' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:52', event: 'Нападение на Dion' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Sailren в Primeval Isle' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:57', event: 'Караван' },
    { time: '16:10', event: 'Mini Battles' },
    { time: '16:30', event: 'Forge Of The Gods' },
    { time: '16:43', event: 'Tower Defence' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:20', event: 'Нападение на Gludio' },
    { time: '17:43', event: 'Holding The Flag' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Sailren в Primeval Isle' },
    { time: '19:23', event: 'Pvp Location' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:10', event: 'Mini Battles' },
    { time: '21:22', event: 'Holding The Flag' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '22:08', event: 'Вечерний босс Greyclaw Kutus' },
    { time: '22:10', event: 'Mini Battles' },
    { time: '22:38', event: 'Вечерний босс Ice Fairy Sirra' },
    { time: '22:55', event: 'Нападение на Dion' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:29', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
  ],
  // Wednesday
  3: [
    { time: '00:00', event: 'Forge Of The Gods' },
    { time: '00:10', event: 'Mini Battles (no buff)' },
    { time: '00:22', event: 'Pvp Location' },
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Sailren в Primeval Isle' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Sailren в Primeval Isle' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:59', event: 'Караван' },
    { time: '12:10', event: 'Mini Battles' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Forge Of The Gods' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:52', event: 'Нападение на Gludio' },
    { time: '16:13', event: 'Mini Battles' },
    { time: '16:30', event: 'Sailren в Primeval Isle' },
    { time: '16:43', event: 'Holding The Flag' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:22', event: 'Pvp Location' },
    { time: '17:43', event: 'Захват флага' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Forge Of The Gods' },
    { time: '19:23', event: 'Holding The Flag' },
    { time: '19:23', event: 'Pvp Location' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:11', event: 'Нападение на Dion' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '21:59', event: 'Queen Ant' },
    { time: '22:37', event: 'Караван' },
    { time: '22:53', event: 'Sailren в Primeval Isle' },
    { time: '23:08', event: 'Вечерний босс Road Scavanger Leader' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
    { time: '23:59', event: 'Нападение на Gludio' },
  ],
  // Thursday
  4: [
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:30', event: 'Forge Of The Gods' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Sailren в Primeval Isle' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Forge Of The Gods' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:52', event: 'Нападение на Dion' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Sailren в Primeval Isle' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:57', event: 'Караван' },
    { time: '16:10', event: 'Mini Battles' },
    { time: '16:30', event: 'Forge Of The Gods' },
    { time: '16:43', event: 'Tower Defence' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:20', event: 'Нападение на Gludio' },
    { time: '17:43', event: 'Захват флага' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Sailren в Primeval Isle' },
    { time: '19:23', event: 'Holding The Flag' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:10', event: 'Mini Battles' },
    { time: '21:22', event: 'Holding The Flag' },
    { time: '21:22', event: 'Pvp Location' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '22:08', event: 'Вечерний босс Greyclaw Kutus' },
    { time: '22:10', event: 'Mini Battles' },
    { time: '22:38', event: 'Вечерний босс Ice Fairy Sirra' },
    { time: '22:58', event: 'Нападение на Dion' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
  ],
  // Friday
  5: [
    { time: '00:00', event: 'Sailren в Primeval Isle' },
    { time: '00:10', event: 'Mini Battles (no buff)' },
    { time: '00:22', event: 'Pvp Location' },
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '03:00', event: 'Forge Of The Gods' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:22', event: 'Pvp Location' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Sailren в Primeval Isle' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:59', event: 'Караван' },
    { time: '12:10', event: 'Mini Battles' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Forge Of The Gods' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:52', event: 'Нападение на Gludio' },
    { time: '16:13', event: 'Mini Battles' },
    { time: '16:30', event: 'Sailren в Primeval Isle' },
    { time: '16:43', event: 'Tower Defence' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:22', event: 'Pvp Location' },
    { time: '17:43', event: 'Захват флага' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Forge Of The Gods' },
    { time: '19:23', event: 'Pvp Location' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:11', event: 'Нападение на Dion' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '22:00', event: 'Golkonda' },
    { time: '22:38', event: 'Вечерний босс Ice Fairy Sirra' },
    { time: '22:58', event: 'Sailren в Primeval Isle' },
    { time: '23:08', event: 'Вечерний босс Road Scavanger Leader' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
    { time: '23:59', event: 'Нападение на Gludio' },
  ],
  // Saturday
  6: [
    { time: '00:30', event: 'Forge Of The Gods' },
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Sailren в Primeval Isle' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Forge Of The Gods' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:52', event: 'Нападение на Dion' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Sailren в Primeval Isle' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:57', event: 'Караван' },
    { time: '16:10', event: 'Mini Battles' },
    { time: '16:30', event: 'Forge Of The Gods' },
    { time: '16:43', event: 'Tower Defence' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:20', event: 'Нападение на Gludio' },
    { time: '17:43', event: 'Holding The Flag' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Sailren в Primeval Isle' },
    { time: '19:23', event: 'Holding The Flag' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:10', event: 'Mini Battles' },
    { time: '21:22', event: 'Pvp Location' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '21:59', event: 'Queen Ant' },
    { time: '22:40', event: 'Караван' },
    { time: '22:58', event: 'Нападение на Dion' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
  ],
  // Sunday
  0: [
    { time: '00:00', event: 'Sailren в Primeval Isle' },
    { time: '00:10', event: 'Mini Battles (no buff)' },
    { time: '00:22', event: 'Pvp Location' },
    { time: '00:43', event: 'Holding The Flag' },
    { time: '01:02', event: 'Караван' },
    { time: '01:10', event: 'Mini Battles' },
    { time: '01:22', event: 'Pvp Location' },
    { time: '01:43', event: 'Tower Defence' },
    { time: '02:00', event: 'Pvp Location' },
    { time: '02:20', event: 'Last Hero' },
    { time: '02:57', event: 'Караван' },
    { time: '03:10', event: 'Mini Battles' },
    { time: '03:22', event: 'Treasures Arena - Small' },
    { time: '03:43', event: 'Захват флага' },
    { time: '04:30', event: 'Forge Of The Gods' },
    { time: '04:43', event: 'Holding The Flag' },
    { time: '05:15', event: 'Караван' },
    { time: '05:43', event: 'Tower Defence' },
    { time: '06:22', event: 'Pvp Location' },
    { time: '06:43', event: 'Захват флага' },
    { time: '07:15', event: 'Караван' },
    { time: '07:43', event: 'Holding The Flag' },
    { time: '08:22', event: 'Treasures Arena - Small' },
    { time: '09:10', event: 'Mini Battles' },
    { time: '09:22', event: 'Pvp Location' },
    { time: '09:57', event: 'Караван' },
    { time: '10:10', event: 'Mini Battles' },
    { time: '10:30', event: 'Sailren в Primeval Isle' },
    { time: '10:43', event: 'Tower Defence' },
    { time: '10:57', event: 'Караван' },
    { time: '11:10', event: 'Mini Battles (no buff)' },
    { time: '11:22', event: 'Treasures Arena - Medium' },
    { time: '11:40', event: 'Holding The Flag' },
    { time: '11:59', event: 'Караван' },
    { time: '12:10', event: 'Mini Battles' },
    { time: '12:27', event: 'Pvp Location' },
    { time: '13:00', event: 'Forge Of The Gods' },
    { time: '13:22', event: 'Захват флага' },
    { time: '13:43', event: 'Pvp Location' },
    { time: '13:57', event: 'Караван' },
    { time: '14:10', event: 'Mini Battles' },
    { time: '14:20', event: 'Открытие подземелья' },
    { time: '14:40', event: 'Появление босса в подземелье' },
    { time: '14:49', event: 'Holding The Flag' },
    { time: '15:02', event: 'Караван' },
    { time: '15:10', event: 'Mini Battles (no buff)' },
    { time: '15:22', event: 'Treasures Arena - Medium' },
    { time: '15:52', event: 'Нападение на Gludio' },
    { time: '16:13', event: 'Mini Battles' },
    { time: '16:30', event: 'Sailren в Primeval Isle' },
    { time: '16:43', event: 'Holding The Flag' },
    { time: '16:57', event: 'Караван' },
    { time: '17:10', event: 'Mini Battles' },
    { time: '17:22', event: 'Pvp Location' },
    { time: '17:43', event: 'Tower Defence' },
    { time: '18:02', event: 'Domination' },
    { time: '18:20', event: 'Открытие подземелья' },
    { time: '18:40', event: 'Появление босса в подземелье' },
    { time: '18:47', event: 'Олимпиада' },
    { time: '18:57', event: 'Караван' },
    { time: '19:13', event: 'Forge Of The Gods' },
    { time: '19:23', event: 'Pvp Location' },
    { time: '19:44', event: 'Treasures Arena' },
    { time: '20:00', event: 'Осада замка' },
    { time: '20:45', event: 'Domination' },
    { time: '21:05', event: 'Олимпиада' },
    { time: '21:11', event: 'Нападение на Dion' },
    { time: '21:39', event: 'Treasures Arena' },
    { time: '22:08', event: 'Вечерний босс Greyclaw Kutus' },
    { time: '22:10', event: 'Mini Battles' },
    { time: '22:38', event: 'Вечерний босс Ice Fairy Sirra' },
    { time: '22:58', event: 'Sailren в Primeval Isle' },
    { time: '23:08', event: 'Вечерний босс Road Scavanger Leader' },
    { time: '23:09', event: 'Открытие подземелья' },
    { time: '23:30', event: 'Появление босса в подземелье' },
    { time: '23:38', event: 'Захват флага' },
    { time: '23:59', event: 'Нападение на Gludio' },
  ],
};

// Server timezone offset in hours (GMT+3)
export const SERVER_TIMEZONE_OFFSET = 3;

// Day names for display
export const DAY_NAMES = {
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  ua: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
};

// Short day names
export const DAY_NAMES_SHORT = {
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  ua: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
};
